import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Download from '../../Icons/Download';

const styles = () => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '13px',
    backgroundColor: '#FFFFFF',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
    cursor: 'pointer',
    transition: '.2s cubic-bezier(0.45, 0, 0.55, 1)',
    "&:hover": {
      background: "rgba(0, 0, 0, 0.12)",
    },
  },
});

class NoMatchCorporationCsvExportPanel extends React.Component {
  render() {
    const { classes, isRender } = this.props;

    return (
      isRender ? (
        <div className={classes.row} style={this.props.style} onClick={this.props.handleClick}>
          <Download width={16} height={16} color="#B1B3B9" style={{ marginRight: '5px' }} />
          <Typography variant="subheading" style={{ color: '#71737B' }}>法人番号での一括検索にて、該当するものがない会社のリストをエクスポート</Typography>
        </div>
      ) : null
    );
  }
}

NoMatchCorporationCsvExportPanel.propTypes = {
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
  isRender: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(NoMatchCorporationCsvExportPanel);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/panels/NoMatchCorporationCsvExportPanel.jsx